var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "home" },
    [
      _c(
        "el-carousel",
        { attrs: { interval: 2000, "indicator-position": "none" } },
        _vm._l(_vm.swiperList, function (item, index) {
          return _c(
            "el-carousel-item",
            {
              key: index,
              staticStyle: { cursor: "pointer" },
              attrs: { arrow: _vm.swiperList.length > 1 ? "hover" : "never" },
              nativeOn: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.jumpUrl(item)
                },
              },
            },
            [
              _c("el-image", {
                staticStyle: { width: "100%" },
                attrs: { src: item.img, fit: "cover" },
              }),
            ],
            1
          )
        }),
        1
      ),
      _vm.visible
        ? _c("div", { staticClass: "inter-health mobile-padding" }, [
            _c("div", { staticClass: "health-title title-big" }, [
              _vm._v(_vm._s(_vm.$t("home.interHealth"))),
            ]),
            _c(
              "div",
              { staticClass: "health-content" },
              [
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      {
                        staticClass: "health-image",
                        attrs: { xs: 24, sm: 24, md: 12 },
                      },
                      [
                        _c("el-image", {
                          attrs: { src: "/svg/inter_health.svg", fit: "cover" },
                        }),
                      ],
                      1
                    ),
                    _c("el-col", { attrs: { xs: 24, sm: 24, md: 12 } }, [
                      _c(
                        "div",
                        { staticClass: "menu" },
                        _vm._l(_vm.interHealthList, function (item, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "menu-item" },
                            [
                              _c("el-image", {
                                attrs: { src: item.icon, fit: "cover" },
                              }),
                              _c("div", { staticClass: "item-text" }, [
                                _vm._v(_vm._s(item.name)),
                              ]),
                            ],
                            1
                          )
                        }),
                        0
                      ),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm.visible
        ? _c(
            "div",
            { staticClass: "inter-hospital mobile-padding" },
            [
              _c(
                "el-row",
                [
                  _c("el-col", { attrs: { xs: 24, sm: 24, md: 8 } }, [
                    _c("div", { staticClass: "common-title " }, [
                      _vm._v(_vm._s(_vm.$t("home.yyInterHospital"))),
                    ]),
                    _c("div", { staticClass: "common-tip" }, [
                      _vm._v(_vm._s(_vm.$t("home.hospitalInfo"))),
                    ]),
                    _c(
                      "div",
                      { staticClass: "common-btn" },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "hidden-sm-and-down",
                            attrs: {
                              type: "primary",
                              size: "medium",
                              round: "",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.jumpRoute("/interHospital/index")
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("home.commonBtn")))]
                        ),
                        _c(
                          "el-button",
                          {
                            staticClass: "hidden-md-and-up",
                            attrs: {
                              type: "primary",
                              size: "small",
                              round: "",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.jumpRoute("/interHospital/index")
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("home.commonBtn")))]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c(
                    "el-col",
                    {
                      staticStyle: { "text-align": "right" },
                      attrs: { xs: 24, sm: 24, md: 16 },
                    },
                    [
                      _c("el-image", {
                        staticClass: "hospital-image hidden-sm-and-down",
                        attrs: { src: _vm.hospitalUrl, fit: "cover" },
                      }),
                      _c("el-image", {
                        staticClass: "hospital-image hidden-md-and-up",
                        attrs: {
                          src: "/img/hospital_feature_mobile.png",
                          fit: "cover",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.visible
        ? _c(
            "div",
            { staticClass: "clini_nutrit mobile-padding" },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    {
                      staticClass: "nutrition hidden-md-and-up",
                      attrs: { xs: 24, sm: 24, md: 14 },
                    },
                    _vm._l(_vm.funcList, function (item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "nutrition-item" },
                        [
                          _c("el-image", {
                            attrs: { src: item.mobile_icon, fit: "cover" },
                          }),
                          _c("div", { staticClass: "item-title" }, [
                            _vm._v(_vm._s(item.title)),
                          ]),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                  _c(
                    "el-col",
                    {
                      staticClass: "nutrition hidden-sm-and-down",
                      attrs: { xs: 24, sm: 24, md: 14 },
                    },
                    _vm._l(_vm.nutritionList, function (item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "nutrition-item",
                          style: { backgroundImage: "url(" + item.icon + ")" },
                        },
                        [
                          _c("div", { staticClass: "item-content" }, [
                            _c("div", { staticClass: "item-title" }, [
                              _vm._v(_vm._s(item.title)),
                            ]),
                            _c("div", { staticClass: "item-tip" }, [
                              _vm._v(_vm._s(item.tip)),
                            ]),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
                  _c("el-col", { attrs: { xs: 24, sm: 24, md: 10 } }, [
                    _c("div", { staticClass: "common-title" }, [
                      _vm._v(_vm._s(_vm.$t("cliniNutrit.cliniNutrit"))),
                    ]),
                    _c("div", { staticClass: "common-tip" }, [
                      _vm._v(_vm._s(_vm.$t("home.cliniNutritTip"))),
                    ]),
                    _c(
                      "div",
                      { staticClass: "common-btn" },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "hidden-sm-and-down",
                            attrs: {
                              type: "primary",
                              size: "medium",
                              round: "",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.jumpRoute("/cliniNutrit/index")
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("home.commonBtn")))]
                        ),
                        _c(
                          "el-button",
                          {
                            staticClass: "hidden-md-and-up",
                            attrs: {
                              type: "primary",
                              size: "small",
                              round: "",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.jumpRoute("/cliniNutrit/index")
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("home.commonBtn")))]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.visible
        ? _c(
            "div",
            {
              staticClass: "inter-hospital mobile-padding",
              staticStyle: { padding: "9.68vw 11vw" },
            },
            [
              _c(
                "el-row",
                [
                  _c("el-col", { attrs: { xs: 24, sm: 24, md: 8 } }, [
                    _c("div", { staticClass: "common-title" }, [
                      _vm._v(_vm._s(_vm.$t("wisdomStore.wisdomStore"))),
                    ]),
                    _c("div", { staticClass: "common-tip" }, [
                      _vm._v(_vm._s(_vm.$t("home.wisdomStoreTip1"))),
                    ]),
                    _c(
                      "div",
                      { staticClass: "common-btn" },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "hidden-sm-and-down",
                            attrs: {
                              type: "primary",
                              size: "medium",
                              round: "",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.jumpRoute("/wisdomStore/index")
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("home.commonBtn")))]
                        ),
                        _c(
                          "el-button",
                          {
                            staticClass: "hidden-md-and-up",
                            attrs: {
                              type: "primary",
                              size: "small",
                              round: "",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.jumpRoute("/wisdomStore/index")
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("home.commonBtn")))]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c(
                    "el-col",
                    {
                      staticStyle: { "text-align": "right" },
                      attrs: { xs: 24, sm: 24, md: 16 },
                    },
                    [
                      _c("el-image", {
                        staticClass: "hospital-image hidden-sm-and-down",
                        staticStyle: { width: "37.5vw" },
                        attrs: { src: _vm.storeUrl, fit: "cover" },
                      }),
                      _c("el-image", {
                        staticClass: "hospital-image hidden-md-and-up",
                        attrs: {
                          src: "/img/store_feature_mobile.png",
                          fit: "cover",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c("div", { staticClass: "technical-super mobile-padding" }, [
        _c("div", { staticClass: "technical-title" }, [
          _vm._v(_vm._s(_vm.$t("home.technicalSuper"))),
        ]),
        _c("div", { staticClass: "technical-temp hidden-sm-and-down" }, [
          _c(
            "div",
            { staticClass: "technical-content " },
            _vm._l(_vm.technicalList, function (item, index) {
              return _c("div", { key: index, staticClass: "technical-item" }, [
                _c("div", { staticClass: "item-title" }, [
                  _vm._v(_vm._s(item.title)),
                ]),
                _c("div", { staticClass: "item-tip" }, [
                  _vm._v(_vm._s(item.tip)),
                ]),
              ])
            }),
            0
          ),
        ]),
        _c(
          "div",
          { staticClass: "technical-temp-mobile hidden-md-and-up" },
          _vm._l(_vm.technicalList, function (item, index) {
            return _c(
              "div",
              { key: index, staticClass: "technical-item" },
              [
                _c("el-image", { attrs: { src: item.icon, fit: "cover" } }),
                _c("div", { staticClass: "item-content" }, [
                  _c("div", { staticClass: "item-title" }, [
                    _vm._v(_vm._s(item.title)),
                  ]),
                  _c("div", { staticClass: "item-tip" }, [
                    _vm._v(_vm._s(item.tip)),
                  ]),
                ]),
              ],
              1
            )
          }),
          0
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }